export default __webpack_public_path__ + "static/media/glade_orchard.638e496d.png";